export const headings = [
  { name: "User" },
  { name: "Time" },
  { name: "status" },
  { name: "Action" },
];
